import React from 'react';

const SkillsSection = ({ data, sectionKey, title }) => {
  const section = data[sectionKey];

  if (!section || !section.enable || section.items.filter(x => x.enable).length === 0) {
    return null;
  }

  const TechSkillsItem = x => (
    <div key={x.id} className="grid grid-cols-3 items-center" style={{ padding: '12px 0 0 0' }}>
      <h6 className="text-sm" style={{ fontWeight: 800 }}>{x.key}</h6>
      {x.years ? <div className="text-sm text-right mr-2">{x.years}</div> : ""}
      <div className="text-sm text-right mr-2">{x.level === '' ? '' : x.level}</div>
    </div>
  );

  return (
    <div style={{ display: "flex", justifyContent: "space-between", borderTop: "2px solid #c63031", padding: '4px 0 16px 0' }}>
      <div className="font-bold tracking-wide text-sm ml-3" style={{ fontSize: 14, color: "#c63031", paddingTop: 12 }}>
        {title}
      </div>
      <div style={{ width: '65%' }}>
        {section.items.filter(x => x.enable).map(TechSkillsItem)}
      </div>
    </div>
  );
};

export default SkillsSection; 